import { gql } from '@apollo/client'

export const ASSIGN_USER_SUPERVISOR = gql`
  mutation AssignUserSupervisor($input: AssignUserSupervisorInput!) {
    assignSupervisor(input: $input) {
      users {
        uuid
        supervisor {
          uuid
        }
      }
    }
  }
`
